import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice/authSlice";
import empReducer from "./empSlice/empSlice";
import auctionReducer from "./auctionSlice/auctionSlice";
import supportTicketReducer from "./supportTicketSlice/supportTicketSlice";
import yardReducer from "./yardSlice/yardSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    emp: empReducer,
    auction: auctionReducer,
    ticket: supportTicketReducer,
    yard: yardReducer,
  },
});
